import router from '@/router'
import store from '@/store'

// 简化的路由守卫，直接放行所有路由
router.beforeEach(async (to, from, next) => {
  // 为了确保store中有基本的用户信息，设置默认状态
  if (!store.getters.token) {
    // 设置默认的用户token和权限
    store.commit('user/SET_TOKEN', 'demo-token')
    store.commit('user/SET_NAME', '袁嘉文')
    store.commit('user/SET_PERMISSIONS', new Set(['all']))
    
    // 生成菜单路由
    try {
      await store.dispatch('permission/GenerateRoutes')
      console.log('菜单路由已生成')
    } catch (error) {
      console.error('生成菜单路由失败:', error)
    }
  }
  
  // 直接放行所有路由
  next()
})
